import { render, staticRenderFns } from "./modalViewEventInfo.vue?vue&type=template&id=34215f52&"
import script from "./modalViewEventInfo.vue?vue&type=script&lang=js&"
export * from "./modalViewEventInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports